module.exports = __webpack_public_path__ + "static/media/chevrons-left.3abeea31.svg";